import _ from "underscore";
import ExpandCollapseNodeRenderer from "../tree/ExpandCollapseNodeRenderer";
import messageResource from "../../messageResource";

export default function UserGroupNodeRenderer( tree, selectorFilter, expandCollapseCallback )
{
    ExpandCollapseNodeRenderer.call(this, tree, selectorFilter, expandCollapseCallback);
}

UserGroupNodeRenderer.prototype = _.create(ExpandCollapseNodeRenderer.prototype);

UserGroupNodeRenderer.prototype.getEmptyEntityTooltip = function()
{
    return messageResource.getMessage("users_selector.expand_collapse_disabled.user_group.tooltip");
};


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/UserGroupNodeRenderer.js